import React, { useEffect, useState } from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import Rank1 from "./Rank1";
import Rank2 from "./Rank2";
import Rank3 from "./Rank3";
import RankTop from "./RankTop";

function makeid(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

function renderMail(length) {
  let result = "";
  const characters = "abcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

function generateRandomFloat(min, max) {
  const highlightedNumber = Math.random() * (max - min) + min;
  return highlightedNumber;
}

export default function RankPage() {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  const [listData, setListData] = useState([]);

  useEffect(() => {
    const cloneData = [];
    for (let index = 0; index < 199; index += 1) {
      cloneData.push({
        rank: index + 3,
        name: `${makeid(3)}*******@${renderMail(2)}****`,
        profit: generateRandomFloat(15, 90),
        amount: generateRandomFloat(80000, 200000),
      });
    }

    setListData(cloneData);
  }, []);

  return (
    <div className="container introduce-page !mt-[70px]">
      <HeaderTop title={i18next.t("rank")} />
      <div className="flex flex-col items-center gap-4 p-4 bg-black">
        <img
          src="https://api.demo92.apptestlive.com/assets/images/best.webp"
          alt="Vip"
          className="w-[384px] max-w-[80%]"
        />
        <div className="flex flex-col w-full  rounded">
          <Rank1 />
          <Rank2 />
          <Rank3 />
          {listData?.map((item, index) => (
            <RankTop key={`item-${index?.toString()}`} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
}
